var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMerchLogo = function SvgMerchLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F2F5FA"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29AAE1",
    d: "M11.962 8.983c-.699 0-1.27-.572-1.27-1.27v-.948c0-.699.571-1.27 1.27-1.27.698 0 1.27.571 1.27 1.27v.948c0 .698-.571 1.27-1.27 1.27",
    transform: "translate(8 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6B3D9",
    d: "M4.7 3.489c-.698 0-1.27-.572-1.27-1.27V1.27C3.43.572 4.002 0 4.7 0 5.4 0 5.97.572 5.97 1.27v.948c0 .7-.57 1.27-1.27 1.27",
    transform: "translate(8 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D86C6",
    d: "M4.7 4.743C2.11 4.743 0 6.852 0 9.444v9.74h2.137v-9.74c0-1.413 1.15-2.564 2.563-2.564 1.413 0 2.564 1.15 2.564 2.564v9.74h2.135v.202l.002-.145V9.444c0-2.592-2.109-4.7-4.7-4.7",
    transform: "translate(8 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D86C6",
    d: "M11.962 10.238c-.944 0-1.824.28-2.561.76-1.25.815-2.09 2.207-2.138 3.795l-.002.145v4.408l.002-.105v-.057h2.135v-4.246l.003-.105c.055-1.365 1.183-2.458 2.56-2.458 1.414 0 2.564 1.15 2.564 2.563v4.246h2.138v-4.246c0-2.592-2.11-4.7-4.701-4.7",
    transform: "translate(8 6)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMerchLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/merch_logo.11dcf768.svg";
export { ForwardRef as ReactComponent };